export default [
  {
    path: "careStaffLibrary",
    name: "careStaffLibrary",
    component: () =>
      import("@/views/communityCare/careStaffLibrary.vue"),
    meta: {
      title: "关怀人员库"
    }
  },
  {
    path: "communityTaskAllocation",
    name: "communityTaskAllocation",
    component: () =>
      import("@/views/communityCare/communityTaskAllocation.vue"),
    meta: {
      title: "关怀人员分配"
    }
  },
  {
    path: "communityMissionDetails",
    name: "communityMissionDetails",
    component: () =>
      import("@/views/communityCare/communityMissionDetails.vue"),
    meta: {
      title: "关怀人员详情"
    }
  },
  {
    path: "theOldManLivedForALongTime",
    name: "theOldManLivedForALongTime",
    component: () =>
      import("@/views/communityCare/theOldManLivedForALongTime.vue"),
    meta: {
      title: "老人旧居未出"
    }
  }
];